<main class="bg-black text-white min-h-screen overflow-x-hidden products-landing">
  <section class="relative pt-28 pb-20 overflow-hidden">
    <div class="absolute inset-0 opacity-[0.03]" style="background-image: linear-gradient(rgba(0,170,230,0.55) 1px, transparent 1px), linear-gradient(90deg, rgba(0,170,230,0.55) 1px, transparent 1px); background-size: 56px 56px;"></div>
    <div class="animated-grid-shift"></div>
    <div class="pulse-ring"></div>
    <div class="hero-particles" aria-hidden="true">
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
    </div>
    <div class="blob blob-one"></div>
    <div class="blob blob-two"></div>
    <div class="absolute inset-0 opacity-[0.03]" style="background-image: linear-gradient(rgba(0,170,230,0.55) 1px, transparent 1px), linear-gradient(90deg, rgba(0,170,230,0.55) 1px, transparent 1px); background-size: 56px 56px;"></div>

    <div class="relative z-10 max-w-7xl mx-auto px-6">
      <a routerLink="/" class="back-nav mb-6 inline-flex" data-aos="fade-down">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" class="w-4 h-4 svg-stroke-gradient"><polyline points="15 18 9 12 15 6"></polyline></svg>
        Back
      </a>
      <p class="text-varroc-accent uppercase tracking-[0.35em] text-xs font-bold mb-4" data-aos="fade-up">Product Hub</p>
      <h1 class="text-3xl md:text-5xl lg:text-6xl font-black leading-tight max-w-none mb-5" data-aos="fade-up" data-aos-delay="100">
        <span class="block text-white md:whitespace-nowrap">One ecosystem. Three product layers.</span>
        <span class="block text-varroc-accent md:whitespace-nowrap">Platform, SDK, and hardware<br> built to work together.</span>
      </h1>
      <p class="text-varroc-text-gray text-base md:text-lg max-w-3xl" data-aos="fade-up" data-aos-delay="180">
        Explore the complete connected product stack in one place, from cloud applications and reusable SDKs to production-ready hardware devices.
      </p>
    </div>
  </section>

  <section class="max-w-7xl mx-auto px-6 pb-12">
    <div class="section-panel" data-aos="fade-up">
      <div class="flex flex-wrap items-end justify-between gap-4 mb-7">
        <div>
          <h2 class="text-3xl md:text-4xl font-black">ConnectIQ</h2>
        </div>
        <a routerLink="/products/connectiq" class="inline-flex items-center gap-2 text-sm font-bold border border-varroc-accent/40 px-4 py-2 rounded-md hover:bg-varroc-accent hover:text-white transition-all">
          Explore ConnectIQ <i class='bx bx-right-arrow-alt text-lg'></i>
        </a>
      </div>

      <div class="grid sm:grid-cols-2 xl:grid-cols-4 gap-4">
        <a *ngFor="let item of connectIqProducts; let i = index"
           [routerLink]="item.route"
           class="nav-card"
           [attr.data-aos]="'fade-up'"
           [attr.data-aos-delay]="(120 + i * 70).toString()">
          <div class="w-11 h-11 rounded-xl bg-varroc-accent/15 border border-varroc-accent/20 flex items-center justify-center mb-4">
            <i class='bx icon-gradient text-2xl' [class]="item.icon"></i>
          </div>
          <div class="text-white font-bold text-lg mb-1">{{ item.title }}</div>
          <div class="text-varroc-text-gray text-sm mb-6">{{ item.subtitle }}</div>
          <div class="inline-flex items-center gap-1 text-varroc-accent text-sm font-semibold">
            Open <i class='bx bx-right-arrow-alt text-lg'></i>
          </div>
        </a>
      </div>
    </div>
  </section>

  <section class="max-w-7xl mx-auto px-6 pb-20 md:pb-28">
    <div class="section-panel" data-aos="fade-up" data-aos-delay="80">
      <div class="flex flex-wrap items-end justify-between gap-4 mb-7">
        <div>
          <h2 class="text-3xl md:text-4xl font-black">Unified SDK</h2>
        </div>
        <a routerLink="/products/unifiedsdk" class="inline-flex items-center gap-2 text-sm font-bold border border-varroc-accent/40 px-4 py-2 rounded-md hover:bg-varroc-accent hover:text-white transition-all">
          Explore Unified SDK <i class='bx bx-right-arrow-alt text-lg'></i>
        </a>
      </div>

      <div class="grid sm:grid-cols-2 gap-4">
        <a *ngFor="let item of sdkProducts; let i = index"
           [routerLink]="item.route"
           class="nav-card"
           [attr.data-aos]="'fade-up'"
           [attr.data-aos-delay]="(140 + i * 70).toString()">
          <div class="w-11 h-11 rounded-xl bg-varroc-accent/15 border border-varroc-accent/20 flex items-center justify-center mb-4">
            <i class='bx icon-gradient text-2xl' [class]="item.icon"></i>
          </div>
          <div class="text-white font-bold text-lg mb-1">{{ item.title }}</div>
          <div class="text-varroc-text-gray text-sm mb-6">{{ item.subtitle }}</div>
          <div class="inline-flex items-center gap-1 text-varroc-accent text-sm font-semibold">
            Open <i class='bx bx-right-arrow-alt text-lg'></i>
          </div>
        </a>
      </div>
    </div>
  </section>

  <section class="max-w-7xl mx-auto px-6 pb-24 md:pb-28">
    <div class="section-panel" data-aos="fade-up">
      <div class="flex flex-wrap items-end justify-between gap-4 mb-7">
        <div>
          <h2 class="text-3xl md:text-4xl font-black">Hardware</h2>
        </div>
        <a routerLink="/products/hardware" class="inline-flex items-center gap-2 text-sm font-bold border border-varroc-accent/40 px-4 py-2 rounded-md hover:bg-varroc-accent hover:text-white transition-all">
          Explore Hardware <i class='bx bx-right-arrow-alt text-lg'></i>
        </a>
      </div>

      <div class="grid sm:grid-cols-2 xl:grid-cols-4 gap-4">
        <a *ngFor="let item of hardwareProducts; let i = index"
           [routerLink]="item.route"
           class="nav-card"
           [attr.data-aos]="'fade-up'"
           [attr.data-aos-delay]="(160 + i * 70).toString()">
          <div class="w-11 h-11 rounded-xl bg-varroc-accent/15 border border-varroc-accent/20 flex items-center justify-center mb-4">
            <i class='bx icon-gradient text-2xl' [class]="item.icon"></i>
          </div>
          <div class="text-white font-bold text-lg mb-1">{{ item.title }}</div>
          <div class="text-varroc-text-gray text-sm mb-6">{{ item.subtitle }}</div>
          <div class="inline-flex items-center gap-1 text-varroc-accent text-sm font-semibold">
            Open <i class='bx bx-right-arrow-alt text-lg'></i>
          </div>
        </a>
      </div>
    </div>
  </section>
</main>
